import { query, collection, onSnapshot, where } from 'firebase/firestore';
import db from "../backend/DBFiresbase";

export const getListaVentaXIndex = (proyecto, numFactura, estado) => {
  onSnapshot(query(collection(db,"proyectos"), where("nombre", "==", proyecto)),
  (querySnapshot) => {
    const docs = [];

    
    querySnapshot.forEach((doc) => {
        const ventaIndex = doc.data().ventas.findIndex(el => el.numDocumento === numFactura );
        docs.push({...doc.data().ventas[ventaIndex]});
    });

    estado(docs[0]);
    
  });
}
